import { API } from 'aws-amplify';

import { setList } from './qualificationListSlice';
import store from '../../../../app/store';
import { listAiClientQualifications } from '../../../../graphql/customQueries';

export const getItems = async () => {
  try {
    let items = [];
    let token;
    do {
      const response = await API.graphql({
        query: listAiClientQualifications,
        variables: { limit: 2000, nextToken: token },
      });
      items = [...items, ...(response.data?.listAiClientQualifications?.items || [])];
      token = response.data?.listAiClientQualifications?.nextToken;
    } while (token);
    store.dispatch(setList(items));
  } catch (e) {
    console.log(e);
  }
};
